module.exports = __webpack_public_path__ + "media/images/favicon-a9e9ed9b6092fecd2bba664efc80a440.ico";